import {getButtonsTemplate} from "./templates";

/**
 * Функционал отвечающий за различные действия с товаром на странице товара, пока только обновление данных на странице updateProductInfo
 *
 * @class Product
 */
class Product {
  #rootElement;
  #vendorCodeElement;
  #codeElement;
  #sizeElement;
  #btnWrapElement;
  #statusElement;
  #nameElement;

  constructor({rootSelector = `.js-product`}) {
    this.#rootElement = document.querySelector(rootSelector);

    if (!this.#rootElement) return;

    this.#init();
  }

  #init() {
    this.#vendorCodeElement = this.#rootElement.querySelector(`.js-product-vendor`);
    this.#codeElement = this.#rootElement.querySelector(`.js-product-code`);
    this.#sizeElement = this.#rootElement.querySelector(`.js-product-size`);
    this.#btnWrapElement = this.#rootElement.querySelector(`.js-product-btn-wrap`);
    this.#statusElement = this.#rootElement.querySelector(`.js-product-status`);
    this.#nameElement = this.#rootElement.querySelector(`.js-product-name`);
  }

  /**
   * Отрисовка необходимых кнопок в зависимости от полученных данных о товаре
   *
   * @param {number} id
   * @param {boolean} isFavorite
   * @param {boolean} isAvailable
   * @param {object} price
   * @param {string} name
   * @param {string} brand
   * @param {string} vendorCode
   * @param {string} size
   * @param {string} image
   * @memberof Product
   */
  #renderRequiredButtons(id, isFavorite, isAvailable, price, name, brand, vendorCode, size, image, cartCount) {
    this.#btnWrapElement.innerHTML = getButtonsTemplate(id, isFavorite, isAvailable, price, name, brand, vendorCode, size, image, cartCount);
  }

  /**
   * Обновление элемента обозначающего статус товара
   *
   * @param {boolean} isAvailable
   * @memberof Product
   */
  #updateStatusElement(isAvailable) {
    const text = isAvailable ? `В наличии` : `Не в наличии`;

    if (isAvailable) {
      this.#statusElement.classList.replace(`card__status--request`, `card__status--available`);
    } else {
      this.#statusElement.classList.replace(`card__status--available`, `card__status--request`);
    }

    this.#statusElement.innerHTML = `<span class="visually-hidden">${text}</span>`;
  }

  /**
   * Обновление текущего адреса страницы
   *
   * @param {string} link
   * @memberof Product
   */
  #updateLocationHref(link) {
    window.history.replaceState({}, "", link);
  }

  /**
   * Обновление данных на странице товара
   *
   * @param {number} id
   * @param {boolean} isFavorite
   * @param {boolean} isAvailable
   * @param {object} price
   * @param {string} name
   * @param {string} brand
   * @param {string} vendorCode
   * @param {string} size
   * @param {Array} images
   * @memberof Product
   */
  updateProductInfo({id, name, link, brand, vendorCode, code, size, isFavorite, isAvailable, price, images, cartCount}) {
    this.#btnWrapElement.removeAttribute("data-in-cart");

    switch (true) {
      case Boolean(this.#vendorCodeElement):
        this.#vendorCodeElement.textContent = vendorCode;
        this.#vendorCodeElement.dataset.copy = vendorCode;
      case Boolean(this.#codeElement):
        this.#codeElement.textContent = code;
        this.#codeElement.dataset.copy = code;
      case Boolean(this.#sizeElement):
        this.#sizeElement.textContent = size;
      case Boolean(this.#btnWrapElement):
        this.#renderRequiredButtons(id, isFavorite, isAvailable, price, name, brand, vendorCode, size, images[0], cartCount);
      case Boolean(this.#statusElement):
        this.#updateStatusElement(isAvailable);
      case Boolean(this.#nameElement):
        this.#nameElement.textContent = name;
    }

    this.#updateLocationHref(link);
  }
}

export {Product};
